import { render, staticRenderFns } from "./coreAdvantage.vue?vue&type=template&id=019ada4e&scoped=true&"
import script from "./coreAdvantage.vue?vue&type=script&lang=js&"
export * from "./coreAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./coreAdvantage.vue?vue&type=style&index=0&id=019ada4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ada4e",
  null
  
)

export default component.exports